/* tslint:disable */
import { User } from './user';

/**
 */
export class LoginView {
    token?: string;
    user?: User;
}
